export default __webpack_public_path__ + "static/media/icon_cross.8ace6265.svg";